module.exports = __webpack_public_path__ + "static/media/reporte.757bb5c7.svg";